import React from 'react';
import { StarIcon } from 'lucide-react';
import { MiniCta } from '../CtaBlock';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="bg-ink-900 px-4 py-14 sm:px-6 sm:py-20" data-id="element-233" data-mp="3mgsjm3aft18b">
      <div className="mx-auto max-w-5xl" data-id="element-234" data-mp="3mfhgm5otfxi9">
        <p className="text-center font-display text-xs font-bold uppercase tracking-[0.22em] text-arc-light" data-id="element-235" data-mp="3r78ylrtwouws">
          ⭐ Cosa dicono i saldatori
        </p>
        <h2 className="mt-3 text-center font-display text-3xl font-bold uppercase leading-tight text-bone sm:text-5xl" data-id="element-236" data-mp="y30b7o0mcu">
          Risultati reali in officina
        </h2>

        <ul className="mt-10 grid gap-4 lg:grid-cols-3" data-id="element-237" data-mp="92xll7ybvyhw">
          {testimonials.map(item => <li key={item.name} className="flex h-full flex-col rounded-2xl border border-ink-500 bg-ink-700 p-5" data-id="element-238" data-mp="dzxrniv6h190">
              <div className="flex items-center gap-3" data-id="element-239" data-mp="2fsc7mce5vvms">
                <img src={item.photo} alt={`Foto di ${item.name}`} className="h-14 w-14 shrink-0 rounded-full border-2 border-arc object-cover" width={112} height={112} data-id="element-240" data-mp="2fsvodps2sdz8" />
                <div className="min-w-0" data-id="element-241" data-mp="1ivrfodzvcxes">
                  <p className="font-display text-lg font-bold uppercase leading-tight text-bone" data-id="element-242" data-mp="1isn58yvt95fo">
                    {item.name}
                  </p>
                  <p className="text-[12px] font-semibold text-mute" data-id="element-243" data-mp="2bjn7b4akzz4p">{item.role}</p>
                </div>
              </div>
              <div className="mt-3 flex gap-0.5" aria-label="5 stelle su 5" data-id="element-244" data-mp="26kttfardu640">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-245" data-mp="22kjqk6yvzvtd" />)}
              </div>
              <blockquote className="mt-3 text-[15px] leading-relaxed text-bone/85" data-id="element-246" data-mp="m4qitddozfwj">
                “{item.quote}”
              </blockquote>
            </li>)}
        </ul>

        <MiniCta label="Voglio gli stessi risultati" data-id="element-247" data-mp="njt6o50k5d8w" />
      </div>
    </section>;
}